/***
 * File name: table.js
 *
 * Program Description:
 * This file contains all the meta configuration of the Personal Data Breach
 * Notification table
 *
 * Includes the ff:
 * - name, collection name, label and other static values for the table
 * - Data view for fetching different formatted data from the server
 * - Route definitions for different actions within the table
 * - Binded varibles
 * - Name of the privilege for role restrictions
 * - Name of table columns/headers indicated as field
 * - Action buttons on top of the table indicAted as tableActions
 * - Action buttons per item inside the tableAindicated as entryActions
 * - Different config for tabs per user roles
 * - List of existing statuses
 * - Other query specifications per tabs
 */
import { capitalize } from '../../../../utils/helpers'

export default function (vm) {
  return {
    name: 'DataBreachTable',
    collectionName: 'DataBreach',
    dataView: 'sorted',
    label: 'Data Breach Notification',
    tableHeader: 'Data Breach Notifications',
    route: {
      updateMultiple: 'pdbnf',
      list: 'pdbnf',
      deleteMultiple: 'pdbnf',
      upload: 'pdbnf',
      updateStatus: 'assign/pdbnf/statusUpdate',
      assignUsers: 'assign/pdbnf',
      viewDbnStatus: 'dbnStatus',
      viewMyProfile: 'user/myprofile',
      reviewers: 'admin/users'
    },
    vBind: {
      singleSelect: true
    },
    // advancedQuery: {
    //   type: 'dataBreach'
    // },
    showExpand: true,
    singleExpand: true,
    hideSelect: true,
    privilege: 'canViewAllPdbnf',
    fields: [
      {
        columnHeader: {
          sortable: !vm.assignTab,
          text: 'DBN No.',
          value: 'dbnNumber'
        }
      },
      {
        columnHeader: {
          sortable: !vm.assignTab,
          text: 'PIC',
          value: 'organization'
        }
      },
      {
        columnHeader: {
          sortable: !vm.assignTab,
          text: 'Date of Occurrence',
          value: 'dateOfOccurrence'
        }
      },
      {
        columnHeader: {
          sortable: !vm.assignTab,
          text: 'Date of Notification',
          value: 'dateOfNotification'
        }
      },
      {
        columnHeader: {
          sortable: !vm.assignTab,
          text: 'Status',
          value: 'status',
          align: 'center'
        }
      },
      {
        columnHeader: {
          sortable: !vm.assignTab,
          text: 'Document Type',
          value: 'documentType',
          align: 'center',
          cellClass: 'pl-0'
        }
      }

    ],
    expandHeaders: [
      'Status',
      'Date and Time',
      'Modified By'
    ],
    assignedUserHeaders: [
      'Evaluator',
      'First Reviewer',
      'Final Reviewer'
    ],
    tableActions: [
      {
        id: 'create',
        label: 'Create',
        icon: 'mdi-plus',
        color: 'white',
        vBind: {
          style: 'background-color: #162b54'
        },
        privilege: 'canPostPdbnf',
        action: () => {
          vm.$router.push({
            name: 'DataBreachCreate',
            params: {
              dataTab: 'pdbnf',
              operation: 'create'
            }
          })
        }
      },
      {
        id: 'settings',
        label: 'Settings',
        icon: 'mdi-cog',
        color: 'primary',
        privilege: 'canViewDaysSetting',
        action: () => {
          vm.$router.push({
            name: 'DataBreachSettings'
          })
        }
      }
    ],
    entryActions: [
      {
        id: 'assign',
        icon: 'mdi-account-plus',
        privilege: 'canViewPdbnf'
      },
      {
        id: 'view',
        icon: 'mdi-eye',
        privilege: 'canViewPdbnf',
        action: (item) => {
          vm.$router.push({
            name: 'DataBreachView',
            params: {
              operation: 'view',
              dataTab: 'pdbnf',
              id: item._id
            }
          })
        }
      },
      {
        id: 'delete-pdbnf',
        icon: 'mdi-radiobox-marked',
        privilege: 'canViewPdbnf'
      }
    ],
    queryTabs: ['For Evaluation', 'For Review', 'For Approval', 'For Fbner', 'All', 'Pending for Assignment'],
    fbnerRoles: ['adjudicationRecipient', 'enforcementRecipient', 'investigationRecipient', 'reviewer', 'evaluator'],
    'all-query': {
      statusQuery: { $ne: 'drafted' }
    },
    'for-fbner-query': {
      statusQuery: { $in: [] }
    },
    'for-review-query': {
      statusQuery: { $in: ['initialreview', 'finalreview', 'initialreviewpbnef', 'finalreviewpbnef'] },
      $or: [
        {
          'assignedTo.firstPass._id': vm.$s.user
        },
        {
          'assignedTo.final._id': vm.$s.user
        }
      ]
    },
    'for-approval-query': {
      statusQuery: { $eq: 'forapprovalpbnef' }
    },
    'for-evaluation-query': {
      statusQuery: { $in: ['forevaluation', 'forevaluationpbnef'] },
      'assignedTo.evaluator._id': vm.$s.user
    },
    'pending-for-assignment-query': {
      statusQuery: { $eq: 'submitted' }
    },
    'pic-query': {
      statusQuery: { $eq: 'active' }
    },
    statuses: {
      adjudicationRecipient: 'foradjudication',
      enforcementRecipient: 'forenforcement',
      investigationRecipient: 'forinvestigation',
      evaluator: 'forevaluationfbner',
      reviewer: ['finalreviewfbner', 'initialreviewfbner', 'forevaluationfbner']
    },
    picTabs: [
      {
        tab: 'All',
        extraHeader: undefined
      }
    ],
    adminTabs: [
      {
        tab: 'All',
        extraHeader: undefined
      }
    ],
    assignorTabs: [
      {
        tab: 'Pending for Assignment',
        extraHeader: {
          sortable: !vm.assignTab,
          text: 'With Request',
          value: 'withRequest',
          align: 'center'
        }
      },
      {
        tab: 'All',
        extraHeader: {
          sortable: !vm.assignTab,
          text: 'Evaluator',
          value: 'assignedTo.evaluator.fullName',
          align: 'center'
        }
      },
      {
        tab: 'All',
        extraHeader: {
          sortable: !vm.assignTab,
          text: 'Reviewer',
          value: 'reviewer',
          align: 'center'
        }
      }
    ],
    reviewerTabs: [
      {
        tab: 'All',
        extraHeader: {
          sortable: !vm.assignTab,
          text: 'Reviewer',
          value: 'reviewer',
          align: 'center'
        }
      },
      {
        tab: 'For Review',
        extraHeader: {
          sortable: !vm.assignTab,
          text: 'Reviewer',
          value: 'reviewer',
          align: 'center'
        }
      },
      {
        tab: 'For Fbner',
        extraHeader: {
          sortable: !vm.assignTab,
          text: 'Reviewer',
          value: 'reviewer',
          align: 'center'
        }
      }
    ],
    evaluatorTabs: [
      {
        tab: 'All',
        extraHeader: {
          sortable: !vm.assignTab,
          text: 'Evaluator',
          value: 'assignedTo.evaluator.fullName',
          align: 'center'
        }
      },
      {
        tab: 'For Evaluation',
        extraHeader: {
          sortable: !vm.assignTab,
          text: 'Evaluator',
          value: 'assignedTo.evaluator.fullName',
          align: 'center'
        }
      },
      {
        tab: 'For Fbner',
        extraHeader: {
          sortable: !vm.assignTab,
          text: 'Evaluator',
          value: 'assignedTo.evaluator.fullName',
          align: 'center'
        }
      }
    ],
    adjudicationRecipientTabs: [
      {
        tab: 'All',
        extraHeader: {
          sortable: !vm.assignTab,
          text: 'Recipient',
          value: 'recipient',
          align: 'center'
        }
      },
      {
        tab: 'For Approval',
        extraHeader: {
          sortable: !vm.assignTab,
          text: 'Recipient',
          value: 'recipient.adjudication.fullName',
          align: 'center'
        }
      },
      {
        tab: 'For Fbner',
        extraHeader: {
          sortable: !vm.assignTab,
          text: 'Evaluator',
          value: 'assignedTo.evaluator.fullName',
          align: 'center'
        }
      }
    ],
    investigationRecipientTabs: [
      {
        tab: 'All',
        extraHeader: {
          sortable: !vm.assignTab,
          text: 'Recipient',
          value: 'recipient',
          align: 'center'
        }
      },
      {
        tab: 'For Fbner',
        extraHeader: {
          sortable: !vm.assignTab,
          text: 'Reviewer',
          value: 'reviewer',
          align: 'center'
        }
      }
    ],
    enforcementRecipientTabs: [
      {
        tab: 'All',
        extraHeader: {
          sortable: !vm.assignTab,
          text: 'Recipient',
          value: 'recipient',
          align: 'center'
        }
      },
      {
        tab: 'For Fbner',
        extraHeader: {
          sortable: !vm.assignTab,
          text: 'Reviewer',
          value: 'reviewer',
          align: 'center'
        }
      }
    ],
    headerKeys: {
      dbnNumber: {
        filter: vm.allItems.filter(item => vm.filter.boxVal.includes(item.dbnNumber)),
        items: vm.allItems.map(item => item.dbnNumber)
      },
      organization: {
        filter: vm.allItems.filter(item => vm.filter.boxVal.includes(item.pic.organization)),
        items: vm.allItems.map(item => item.pic.organization)
      },
      dateOfOccurrence: {
        filter: vm.allItems.filter(item => vm.filter.boxVal.includes(item.dateOfOccurrence && item.dateOfOccurrence.split(' ')[0])),
        items: vm.allItems.map(item => item.dateOfOccurrence && item.dateOfOccurrence.split(' ')[0])
      },
      dateOfNotification: {
        filter: vm.allItems.filter(item => vm.filter.boxVal.includes(item.dateOfNotification)),
        items: vm.allItems.map(item => item.dateOfNotification)
      },
      withRequest: {
        filter: vm.allItems.filter(item => vm.filter.boxVal.includes(item.withRequest === 'No' ? 'None' : 'Yes')),
        items: vm.allItems.map(item => item.withRequest === 'No' ? 'None' : 'Yes')
      },
      status: {
        filter: vm.allItems.filter(item => vm.filter.boxVal.includes(item.status.value) || vm.filter.boxVal.includes(capitalize(item._status))),
        items: [...vm.allItems.map(item => item.status.value), 'Invalid']
      },
      documentType: {
        filter: vm.allItems.filter(item => vm.filter.boxVal.includes(item.documentType)),
        items: vm.allItems.map(item => item.documentType)
      },
      'assignedTo.evaluator.fullName': {
        filter: vm.allItems.filter(item => vm.filter.boxVal.includes(item.assignedTo.evaluator.fullName)),
        items: vm.allItems.map(item => item.assignedTo.evaluator.fullName)
      },
      reviewer: {
        filter: vm.allItems.filter(item => vm.filter.boxVal.includes(item.assignedTo.firstPass.fullName) || vm.filter.boxVal.includes(item.assignedTo.final.fullName)),
        items: undefined
      }
    }
  }
}
